/* eslint-disable no-nested-ternary */
import React from 'react';
import FormFile from '../forms/FormFile';
import Main from '../components/Main';
import PageActionsFile from '../components/PageActionsFile';
import { useFileCreateContext } from '../context/FileCreateContext';

const CreateReverseMortgage = () => {
  const { isLoading, createFile } = useFileCreateContext();
  return (
    <Main pagetitle="Create File">
      <PageActionsFile mode="CREATE" data={null} isLoading={isLoading} formId="createFile" />
      <FormFile mode="CREATE" data={null} isLoading={isLoading} onSubmit={createFile} formId="createFile" />
    </Main>
  );
};
export default CreateReverseMortgage;
